module.exports = __webpack_public_path__ + "img/html-5-logo-svgrepo-com.5b5420a4.svg";